import type { NotificationAnalyticsProps } from '@/utils/hooks/context/toast/types';

// Components
import FirstStatsReady from '@/components/composite/Notifications/Analytics/FirstStatsReady';

const NotificationsAnalytics = ({ notification }: NotificationAnalyticsProps) => {
    const type = notification.type;
    switch (type) {
        case 'first_stats_ready':
            return <FirstStatsReady notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsAnalytics;
